// Deliberately imported from `@/i18n/locales` and not `@/i18n/routing`: this is a pure
// path helper used from the proxy, and `routing` drags in next-intl's react-client
// navigation module.
import { defaultLocale, isLocaleCode, LocaleCode, locales } from '@/i18n/locales';

export const stripLocalePrefix = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean);
  if (!isLocaleCode(segments[0] ?? '')) {
    return pathname;
  }
  return `/${segments.slice(1).join('/')}`;
};

export const getLocaleFromPathname = (pathname: string): LocaleCode => {
  const match = pathname.match(/^\/([a-z]{2})(?:\/|$)/);
  const candidate = match?.[1];
  if (candidate && (locales as readonly string[]).includes(candidate)) {
    return candidate as LocaleCode;
  }
  return defaultLocale;
};

export const buildLocalizedPath = (locale: LocaleCode, pathname: string): string => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (locale === defaultLocale) {
    return normalizedPath;
  }
  if (normalizedPath === '/') {
    return `/${locale}`;
  }
  return `/${locale}${normalizedPath}`;
};
